import { createRouter, createWebHistory } from 'vue-router'
import { useStore } from 'vuex'

// Import des vues
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import ProfileView from '../views/ProfileView.vue'
import AdminView from '../views/AdminView.vue'
import MatchesView from '../views/MatchesView.vue'
import RankingsView from '../views/RankingsView.vue'
import StatisticsView from '../views/StatisticsView.vue'
import MessagesView from '../views/MessagesView.vue'
import HomeView from '../views/HomeView.vue'

const routes = [
  // Routes publiques
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: false }
  },
  {
    path: '/home',
    redirect: { name: 'home' }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: { requiresAuth: false }
  },
  

  {
    path: '/profile',
    name: 'profile',
    component: ProfileView,
    meta: { requiresAuth: true }
  },
  
  // Routes admin (nécessitent une authentification et un rôle admin)
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/rankings',
    name: 'rankings',
    component: RankingsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/matches',
    name: 'matches',
    component: MatchesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: StatisticsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/messages',
    name: 'messages',
    component: MessagesView,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const store = useStore()
  const isAuthenticated = store.getters['auth/isLoggedIn']
  const isAdmin = store.getters['auth/isAdmin']

  // Redirection vers login si authentification requise
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }

  // Redirection vers home si accès admin requis sans être admin
  if (to.meta.requiresAdmin && !isAdmin) {
    next({ name: 'home' })
    return
  }

  // Redirection vers home si déjà authentifié et tentative d'accès à login/register
  if (isAuthenticated && (to.name === 'login' || to.name === 'register')) {
    next({ name: 'home' })
    return
  }

  next()
})

export default router 